import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { categories } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { CheckboxWithLabel, TextField } from 'formik-material-ui'
import { SelectField } from '../../../../components/selectField'
import { useSelector } from 'react-redux'
import { navLinksProduct } from '../../../../services/product'

interface CategoryEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function CategoryEditPage(props: CategoryEditPageProps): JSX.Element {
    useEffect(() => {
        dispatch(categories.actions.fetch())
    }, [])

    const dispatch = useAppDispatch()
    const history = useHistory()

    const category = useAppSelector((state) => categories.selectors.selectById(state, props.match.params.id))
    const parentsList = useSelector(categories.selectors.selectAll)

    const initialValues = {
        id: category?.iri || '',
        name: category?.name || '',
        marked: category?.marked || false,
        parent: category?.parent?.iri || '',
    }

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(categories.actions.update({iri: values.id, data: values}))
                    .then(unwrapResult)
                    .then(() => {
                        history.goBack()
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksProduct}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Редактирование категории'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                        validate={validation.required}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={CheckboxWithLabel}
                                        Label={{ label: 'Маркировка' }}
                                        name="marked"
                                        type="checkbox"
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={SelectField}
                                        label="Родитель"
                                        name="parent"
                                        fullWidth
                                        nullable
                                        nullableText={'Не выбрано'}
                                        items={parentsList.map((item) => ({value: item.iri, label: item.name}))}
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}